'use strict';

customerZone.service('BudskapService', ['BudskapClient', 'utils', '$log', '$q', function(buddy, utils, $log, $q){

    var self = this;
    var displayedIds = [];

    var displayMessage = function(level, content) {
        level = level ? level : 'warning';
        var supportedLevels = {
            info: function(message){ utils.showInfo(message); },
            warning: function(message){ utils.showWarn(message); },
            error: function(message){ utils.showError(message); }
        };
        var display = supportedLevels[level];
        display(content);
    };

    self.displayGeneralNotifications = function(){
        self.displayNotifications();
    };

    self.displayNotifications = function(contexts){
        if (!contexts) contexts = [undefined];
        $q.all(contexts.map(function(context){ return buddy.getNotifications(context); }))
            .then(flatten)
            .then(function(notifications){
                notifications.forEach(displayNotification);
            })
            .catch(function(error){
                $log.error('Unable to get budskap notifications', error);
            });
    };

    var displayNotification = function(notification){
        if (displayedIds.includes(notification.id)) return;
        displayMessage(notification.level, notification.body);
        displayedIds.push(notification.id);
    };

    self.addressUpdated = function(){
        return buddy.sendAddressUpdatedEvent();
    };

    var flatten = function(listOfLists){
        var result = [];
        listOfLists.forEach(function(list){
            [].push.apply(result, list);
        });
        return result;
    };

}]);
